import Layout from "Components/Layout";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import CommonClasses from "Styles/Common.module.css";
import { SuccessSwal, warningSwal } from "Util/Toast";
import { Services } from "Services";
import SkeletonLoad from "Components/TableLoad/load";
import { AccessKeys } from "Routes/config";
import { useNavigate } from "react-router-dom";
import { BiPlus } from "react-icons/bi";
import { AccessControl } from "Util/AccessControl";
import { FaRegEdit } from "react-icons/fa";
import { ConfirmationDiaolog } from "Util/Toast";
import { FaDeleteLeft } from "react-icons/fa6";
import { MdDelete } from "react-icons/md";
function Application() {
    const Navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    const token = { Authorization: `token ${localStorage.getItem("token")}` };
    const getRoles = () => {
        Services.getJobOpenings("GET", null, token)
            .then((response) => {
                console.log(response);
                setTimeout(() => {
                    setLoading(false);
                }, 200);
                if (response.Status === 1) {
                    setData(response.JobOpenings);
                } else if (response.Status === 0) {
                    warningSwal("Warning", response.Message);
                }
            })
            .catch((err) => {
                setLoading(false);
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    const DeleteJob = (JobOpeningsID) => {
        Services.DeleteJobOpenings("DELETE", null, token, JobOpeningsID)
            .then((response) => {
                console.log(response);
                setTimeout(() => {
                    setLoading(false);
                }, 200);
                if (response.Status === 1) {
                    SuccessSwal("Success", "Job Opening Deleted");
                    getRoles();
                } else if (response.Status === 0) {
                    warningSwal("Warning", response.Message);
                }
            })
            .catch((err) => {
                setLoading(false);
                // alert(err);
                alert("something went wrong please try again");
                console.log(err);
            });
    };
    useEffect(() => {
        getRoles();
    }, []);
    let head = ["Role", "Experience", "Location", "Status"];

    const editHandler = (e) => {
        e.stopPropagation();
        e.preventDefault();
        let id = e.currentTarget.getAttribute("id");
    };
    return (
        <Layout Active={"Openings"}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Openings</title>
            </Helmet>
            <div className={CommonClasses["Container"]}>
                <div className={CommonClasses["control-btns"]}>
                    {AccessControl(AccessKeys["Career Roles"]).write == 1 && (
                        <button
                            className={CommonClasses["button"]}
                            onClick={() => {
                                Navigate("/career/openings/add");
                            }}>
                            <BiPlus size={20} /> Create New Opening
                        </button>
                    )}
                </div>
                <div className={CommonClasses["wrapper"]}>
                    <h3>Openings</h3>
                    {loading ? (
                        <SkeletonLoad TableHead={head} />
                    ) : (
                        <>
                            <div className={CommonClasses["Table"]}>
                                <table>
                                    <thead>
                                        <tr>
                                            {head.map((item, index) => (
                                                <th key={index}>{item}</th>
                                            ))}
                                            {AccessControl(AccessKeys.Openings)
                                                ?.edit === 1 && (
                                                <th>Actions</th>
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.length > 0 ? (
                                            data.map((item, index) => (
                                                <tr
                                                    key={index}
                                                    style={{
                                                        height: "3rem",
                                                    }}>
                                                    <td>{item.Role}</td>
                                                    <td>{item.Experience}</td>
                                                    <td>{item.Address}</td>
                                                    <td>
                                                        {" "}
                                                        {item.Status === 1 ? (
                                                            <div
                                                                className={
                                                                    CommonClasses[
                                                                        "Status-active"
                                                                    ]
                                                                }>
                                                                <span>
                                                                    Active
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            <div
                                                                className={
                                                                    CommonClasses[
                                                                        "Status-inactive"
                                                                    ]
                                                                }>
                                                                <span>
                                                                    Inactive
                                                                </span>
                                                            </div>
                                                        )}
                                                    </td>
                                                    {AccessControl(
                                                        AccessKeys.Openings
                                                    )?.edit === 1 && (
                                                        <td>
                                                            <div
                                                                className={
                                                                    CommonClasses[
                                                                        "Action-btns"
                                                                    ]
                                                                }>
                                                                <button
                                                                    id={
                                                                        item.RoleID
                                                                    }
                                                                    onClick={() => {
                                                                        Navigate(
                                                                            `/career/openings/update?id=${item.JobOpeningsID}`,
                                                                            {
                                                                                state: item,
                                                                            }
                                                                        );
                                                                    }}>
                                                                    <FaRegEdit />
                                                                </button>
                                                                <button
                                                                    id={
                                                                        item.RoleID
                                                                    }
                                                                    onClick={() => {
                                                                        ConfirmationDiaolog(
                                                                            "Are you sure you want to delete this job opening?",
                                                                            "Delete",
                                                                            () =>
                                                                                DeleteJob(
                                                                                    item.JobOpeningsID
                                                                                )
                                                                        );
                                                                    }}>
                                                                    <MdDelete />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    )}
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan={head.length}>
                                                    No Opening Found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </Layout>
    );
}

export default Application;
